import { render, staticRenderFns } from "./score_table.vue?vue&type=template&id=299aedea&scoped=true&"
import script from "./score_table.vue?vue&type=script&lang=ts&"
export * from "./score_table.vue?vue&type=script&lang=ts&"
import style0 from "./score_table.vue?vue&type=style&index=0&id=299aedea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299aedea",
  null
  
)

export default component.exports